import { createAsyncSelectors } from '@lib/selectors';
import { ViewForm } from './ViewForm';
import { coreActions, DataDictionaryView } from '@sonar-software/sonar-core';
import React, { useEffect, useRef } from 'react';
import { useAction, useAsyncState, useOnUnmount } from '@hooks';

export interface RenameViewProps {
	onCancel: () => void;
	onFinish: () => void;
	view: DataDictionaryView;
}

const updateViewSelectors = createAsyncSelectors((state) => state.core.dataDictionary.views.patch);

export const RenameView: React.FC<RenameViewProps> = ({ onCancel, onFinish, view }) => {
	const { isReceived, isRequested } = useAsyncState(updateViewSelectors);

	const updateView = useAction(coreActions.requestPatchCoreDataDictionaryViews);
	const resetUpdate = useAction(coreActions.resetPatchCoreDataDictionaryViews);

	const onFinishRef = useRef(onFinish);
	onFinishRef.current = onFinish;

	useOnUnmount(resetUpdate);

	useEffect(() => {
		if (isReceived) {
			onFinishRef.current();
		}
	}, [ isReceived ]);

	return (
		<ViewForm
			currentName={ view.name }
			onCancel={ onCancel }
			onSubmit={ (viewName: string) => {
				updateView({
					viewId: view.id,
					viewName: viewName?.trim()
				});
			} }
			processing={ isRequested } />
	);
};
